import {connect} from 'react-redux';
import {IReduxStoreState} from '../@interfaces';
import React from 'react';

export default function localeConnector(component: React.ComponentType<any>) {
	const connector = connect(
		(state: IReduxStoreState) => ({locale: state.locale.locale})
	);

	return connector(component);
}
